/**
 * PageBreadcrumb - Reusable breadcrumb navigation component
 * 
 * Usage:
 * <PageBreadcrumb items={[
 *   { label: 'Library', href: '/library' },
 *   { label: 'AML/CFT/PF' }  // Current page (no href)
 * ]} />
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { House, CaretRight } from '@phosphor-icons/react';

const PageBreadcrumb = ({ items = [] }) => {
  return (
    <nav 
      aria-label="Breadcrumb" 
      className="flex items-center gap-2 text-sm mb-4"
      data-testid="page-breadcrumb"
    >
      {/* Dashboard Home */}
      <Link 
        to="/dashboard" 
        className="flex items-center gap-1.5 text-text-tertiary hover:text-gold transition-colors"
      >
        <House size={16} weight="fill" />
        <span>Dashboard</span>
      </Link>

      {/* Breadcrumb Items */}
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        
        return (
          <React.Fragment key={index}>
            <CaretRight size={14} className="text-text-tertiary" />
            {isLast || !item.href ? (
              <span className="text-text-primary font-medium">
                {item.label}
              </span>
            ) : (
              <Link 
                to={item.href} 
                className="text-text-tertiary hover:text-gold transition-colors"
              >
                {item.label}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default PageBreadcrumb;
